import Phaser from 'phaser';

import './css/style.css';

import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';
import SliderPlugin from 'phaser3-rex-plugins/plugins/slider-plugin.js';

import Boot from './js/scenes/Boot.js';
import Preloader from './js/scenes/Preloader.js';
import Menu from './js/scenes/Menu.js';
import Game from './js/scenes/Game.js';
import Quiz from './js/scenes/Quiz.js';
import GameOver from './js/scenes/GameOver.js';
import GameEnd from './js/scenes/GameEnd.js';
import GameTuto from './js/scenes/GameTuto.js';
import Test from './js/scenes/Test.js';

//Création du jeu
var game;

window.onload = function () {
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;
    var config = {
        pixelArt: false,
        antialias: true,
        roundPixels: true,
        autoResize: true,
        width: 1920 * 0.82,
        height: 1080 * 0.593,
        backgroundColor: '#FFFFFF',
        type: Phaser.AUTO,
        parent: 'game',
        scale: {
            mode: isMobile ? Phaser.Scale.FIT : Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
        },
        dom: {
            createContainer: true,
        },
        plugins: {
            global: [
                {
                    key: 'rexRoundRectanglePlugin',
                    plugin: RoundRectanglePlugin,
                    start: true,
                },
                {
                    key: 'rexTagTextPlugin',
                    plugin: TagTextPlugin,
                    start: true,
                },
                {
                    key: 'rexSlider',
                    plugin: SliderPlugin,
                    start: true,
                },
            ],
        },
        fps: {
            target: 30,
            forceSetTimeOut: true,
        },
        scene: [Boot, Preloader, Menu, Game, Quiz, GameOver, GameEnd, GameTuto, Test],
    };

    game = new Phaser.Game(config);

    // console.log('  __       __|  __  ');
    // console.log('__)  (__| (__| (__) ');
    // console.log('        |           ');

    game.scene.start('Boot');
};
